import _regeneratorRuntime from "/workspace/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/workspace/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/workspace/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { ethers } from 'ethers';
import { ConnectorJson, Organization, toNetwork } from '@aragon/connect-core';
import ConnectorEthereum from '@aragon/connect-ethereum';
import ConnectorTheGraph from '@aragon/connect-thegraph';
import { XDAI_WSS_ENDPOINT, DEFAULT_IPFS_URL } from './constants';

function ipfsResolverFromUrlTemplate(urlTemplate) {
  return function ipfsResolver(cid, path) {
    var url = urlTemplate.replace(/\{cid\}/, cid);

    if (!path) {
      return url.replace(/\{path\}/, '');
    }

    if (!path.startsWith('/')) {
      path = "/".concat(path);
    }

    return url.replace(/\{path\}/, path);
  };
}

function getIpfsResolver(ipfs) {
  if (typeof ipfs === 'function') {
    return ipfs;
  }

  return ipfsResolverFromUrlTemplate(ipfs || DEFAULT_IPFS_URL);
}

function normalizeConnectorConfig(connector) {
  if (Array.isArray(connector)) {
    return [connector[0], connector[1] || {}];
  }

  if (typeof connector === 'string') {
    return [connector, {}];
  }

  return null;
}

function getConnector(connector, network) {
  var normalizedConfig = normalizeConnectorConfig(connector);

  if (normalizedConfig === null) {
    return connector;
  }

  var _normalizedConfig = _slicedToArray(normalizedConfig, 2),
      name = _normalizedConfig[0],
      config = _normalizedConfig[1];

  if (!config.network) {
    config.network = network;
  }

  if (name === 'json') {
    return new ConnectorJson(config);
  }

  if (name === 'thegraph') {
    return new ConnectorTheGraph(config);
  }

  if (name === 'ethereum') {
    return new ConnectorEthereum(config);
  }

  throw new Error("Unsupported connector name: ".concat(name));
}

function getEthersProvider(ethereumProvider, network) {
  // Ethers compatibility: ethereum => homestead
  if (network.name === 'ethereum' && network.chainId === 1) {
    network = _objectSpread({}, network, {
      name: 'homestead'
    });
  }

  if (ethereumProvider) {
    try {
      return new ethers.providers.Web3Provider(ethereumProvider, network);
    } catch (err) {
      console.error('Invalid provider:', ethereumProvider);
      throw err;
    }
  }

  if (network.chainId === 100) {
    return new ethers.providers.WebSocketProvider(XDAI_WSS_ENDPOINT, network);
  }

  return ethers.getDefaultProvider(network);
}

function resolveAddress(_x, _x2) {
  return _resolveAddress.apply(this, arguments);
}

function _resolveAddress() {
  _resolveAddress = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(ethersProvider, location) {
    var address;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!ethers.utils.isAddress(location)) {
              _context.next = 4;
              break;
            }

            _context.t0 = location;
            _context.next = 7;
            break;

          case 4:
            _context.next = 6;
            return ethersProvider.resolveName(location);

          case 6:
            _context.t0 = _context.sent;

          case 7:
            address = _context.t0;

            if (ethers.utils.isAddress(address)) {
              _context.next = 10;
              break;
            }

            throw new Error('Please provide a valid address or ENS domain.');

          case 10:
            return _context.abrupt("return", address);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _resolveAddress.apply(this, arguments);
}

function connect(_x3, _x4) {
  return _connect.apply(this, arguments);
}

function _connect() {
  _connect = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(location, connector) {
    var _ref,
        actAs,
        ethereumProvider,
        ipfs,
        network,
        verbose,
        _a,
        _network,
        ethersProvider,
        orgConnector,
        orgAddress,
        connectionContext,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _ref = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {}, actAs = _ref.actAs, ethereumProvider = _ref.ethereum, ipfs = _ref.ipfs, network = _ref.network, verbose = _ref.verbose;
            _network = toNetwork(network !== null && network !== void 0 ? network : 'ethereum');
            ethersProvider = getEthersProvider(ethereumProvider, _network);
            orgConnector = getConnector(connector, _network);
            _context2.next = 6;
            return resolveAddress(ethersProvider, location);

          case 6:
            orgAddress = _context2.sent;
            connectionContext = {
              actAs: actAs || null,
              ethereumProvider: ethereumProvider || null,
              ethersProvider: ethersProvider,
              ipfs: getIpfsResolver(ipfs),
              network: _network,
              orgAddress: orgAddress,
              orgConnector: orgConnector,
              orgLocation: location,
              verbose: verbose !== null && verbose !== void 0 ? verbose : false
            };
            _context2.next = 10;
            return (_a = orgConnector.connect) === null || _a === void 0 ? void 0 : _a.call(orgConnector, connectionContext);

          case 10:
            return _context2.abrupt("return", new Organization(connectionContext));

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _connect.apply(this, arguments);
}

export default connect;